import React, { useState } from 'react';
import { useCookieConsent } from '../../contexts/CookieConsentContext';
import CookiePreferencesModal from './CookiePreferencesModal';
import { Settings } from 'lucide-react';

const CookieBanner: React.FC = () => {
  const { consentStatus, acceptAll, rejectAll } = useCookieConsent();
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (consentStatus?.hasConsented) return null;

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-white shadow-lg transform translate-y-0 transition-transform duration-300 ease-in-out">
        <div className="container mx-auto px-4 py-4 sm:py-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex-1 pr-4">
              <p className="text-sm sm:text-base text-gray-600">
                Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten. 
                Einige sind essenziell für den Betrieb der Website, während andere uns helfen, 
                diese zu verbessern und Ihr Nutzererlebnis zu optimieren.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full sm:w-auto">
              <button
                onClick={() => setIsModalOpen(true)}
                className="inline-flex items-center justify-center px-4 py-2 border border-gray-300 rounded-xl text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-success"
              >
                <Settings className="w-4 h-4 mr-2" />
                Einstellungen
              </button>
              <button
                onClick={rejectAll}
                className="inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-xl text-sm font-medium text-success bg-success/10 hover:bg-success/20 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-success"
              >
                Ablehnen
              </button>
              <button
                onClick={acceptAll}
                className="inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-xl text-sm font-medium text-white bg-success hover:bg-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-success"
              >
                Alle akzeptieren
              </button>
            </div>
          </div>
        </div>
      </div>

      <CookiePreferencesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default CookieBanner;